import React from "react";
import { ComplexSensor } from "./ComplexSensor";
import FxContentBox from "../fxms/components/FxContentBox";
import { VupComDash } from "./VupComDash";

import "./../css/VUP_dash.css";

/*총괄대시보드*/
export const VupAdminDash = () => {

  return (
    <>
      <div id="wrapper">
        <div id="dashPart">
          <div className="lineGroup">
            <ComplexSensor complexInloNo={14000} />
          </div>
          <div className="lineGroup mt20 mb20">
            <ComplexSensor complexInloNo={11000} />
          </div>   
          <div className="lineGroup mb20">
            <ComplexSensor complexInloNo={13000} />
          </div>          
        </div>
      </div>
    </>
  );
};